import Problem from "features/cases/blocks/Problem";
import React, { useState } from "react";

import PageLayout from "../../common/PageLayout";

const NewProblemPage: React.FC = () => {
  const [solsExpanded, setSolsExpanded] = useState(false);
  const [probExpanded, setProbExpanded] = useState(false);
  const [caseExpanded, setCaseExpanded] = useState(false);

  return (
    <PageLayout withFooter={false}>
      <Problem
        problemId={null}
        solutionId={undefined}
        solsExpanded={solsExpanded}
        setSolsExpanded={setSolsExpanded}
        probExpanded={probExpanded}
        setProbExpanded={setProbExpanded}
        caseExpanded={caseExpanded}
        setCaseExpanded={setCaseExpanded}
        isNewProblemPage={true}
      />
    </PageLayout>
  );
};

export default NewProblemPage;
